import { render, staticRenderFns } from "./AlertConfirm.vue?vue&type=template&id=32883ff8&scoped=true&"
import script from "./AlertConfirm.vue?vue&type=script&lang=js&"
export * from "./AlertConfirm.vue?vue&type=script&lang=js&"
import style0 from "./AlertConfirm.vue?vue&type=style&index=0&id=32883ff8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32883ff8",
  null
  
)

export default component.exports